// Client for the demo server's JSON API.

export interface ClassProbs { name: number; gibberish: number; word: number }
export interface TokenScore { token: string; probs: ClassProbs; lexicon?: 'name' | 'word'; nameScore: number; skipped?: boolean }
export interface NameResult {
  verdict: 'accept' | 'confirm' | 'reject';
  reason: string;
  name?: string;
  firstName?: string;
  confidence: number;
  stage: 'rules' | 'model';
  rule?: string;
  extractedFrom?: string;
  tokens: TokenScore[];
  ms: number;
}
export interface JudgeResult { outcome: 'correct' | 'incorrect' | 'unclear'; extracted: string | null; method: string; rule: string; ms: number }
export interface ModelInfo {
  type: string; features: number; trainSamples: number; validationSamples: number;
  perClass: Record<string, number>; validationAccuracy: number; validationRecall: Record<string, number>; sizeKb: number;
}

async function post<T>(path: string, body: unknown): Promise<T> {
  const res = await fetch(path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
  if (!res.ok) throw new Error(`${path}: ${res.status}`);
  return res.json() as Promise<T>;
}

export const api = {
  session: () => post<{ id: string }>('/api/session', {}),
  name: (text: string, attempt: number, session?: string) => post<NameResult>('/api/name', { text, attempt, session }),
  answer: (text: string, expected: string) => post<JudgeResult>('/api/answer', { text, expected }),
  model: async () => (await fetch('/api/model')).json() as Promise<ModelInfo>,
  /** True when the server answers within the timeout. */
  ping: async (timeoutMs = 1500): Promise<boolean> => {
    try {
      const res = await fetch(`/api/ping?t=${Date.now()}`, { cache: 'no-store', signal: AbortSignal.timeout(timeoutMs) });
      return res.ok;
    } catch { return false; }
  },
};
